export default __webpack_public_path__ + "static/media/t3.cda20f2c.png";